<template>
  <el-switch @change="change" size="mini" v-model="isFixedRate"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      isFixedRate: false
    }
  },
  beforeMount() {
    this.isFixedRate = (this.params.data.is_fixed === 1)
  },
  methods: {
    change(val) {
      let params = {
        value: val,
        id: this.params.data.id
      }
      this.params.props.actionsHandler('setIsFixedRate', params)
    }
  }
}
</script>
